import { GetMessages } from "../api/APICalls";
import {
  MESSAGE_DEFAULT,
  MESSAGE_FULFILLED,
  MESSAGE_REJECTED,
  MESSAGE_CLEAR
} from "./messageActionTypes";

const GetMessageData = (dispatch) => {
  dispatch({ type: MESSAGE_DEFAULT, payload: null });

  const payload = {
    Secret: "ef95e17b-822c-481b-a277-1e12c83f567f"
  };

  let myPromise = GetMessages(payload, {});
  myPromise.then(function(response) {
    console.log(response);
  
    if (response.status >= 200 && response.status < 300) {
      myPromise = response.json();
      myPromise.then(function(responseBody) {
        console.log(responseBody);
  
        dispatch({ type: MESSAGE_FULFILLED, payload: responseBody });
      });
    } else {
        dispatch({ type: MESSAGE_REJECTED, payload: null });
    }
  });
};

const ClearMessageData = () => ({
  type: MESSAGE_CLEAR,
});

export {
  GetMessageData,
  ClearMessageData,
};
